export type MpsDocument = {
  documentId: string;
  idempotencyId: string;
  type: string;
  status: string;
};

export type MpsDocumentsDossier = {
  payoutId: string;
  documents: MpsDocument[];
};

export type PayoutStatus = 'sent_to_bank' | 'in_progress' | 'kyc_failed' | 'not_applicable';

export type MerchantPayoutLevelInfo = {
  merchantId: string;
  payoutLevel: PayoutLevel;
};

export type VenuePayout = {
  id: string;
  payoutNumber: number | null;
  country: Country;
  currency: Currency;
  doNotPay: boolean;
  endDate: string;
  interval: 'hexa_monthly' | 'semi_monthly' | 'weekly' | 'monthly' | 'custom';
  intervalNumber: number;
  numberOfPurchases: number;
  payoutAmount: number;
  startDate: string;
  toAccount: string;
  transferStatus: PayoutStatus;
  venue: string;
  year: number;
  invoiceDossierExists: boolean;
  csvReportExists: boolean;
  isMpsPayout: boolean;
  endToEndId: number;
};

export enum MerchantPayoutStatus {
  SUCCESS = 'SUCCESS',
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
  NO_VENUES = 'NO_VENUES',
  CURRENCY_MISMATCH = 'CURRENCY_MISMATCH',
  PAYOUT_DISABLED = 'PAYOUT_DISABLED',
  PAYOUT_DISABLED_VALIDATED = 'PAYOUT_DISABLED_VALIDATED',
  MISSING_VAT_ID = 'MISSING_VAT_ID',
  VAT_ID_VALIDATED = 'VAT_ID_VALIDATED',
  KYB_PENDING = 'KYB_PENDING',
  KYB_VALIDATED = 'KYB_VALIDATED',
  CURRENCY_VALIDATED = 'CURRENCY_VALIDATED',
  MISSING_CREDITOR_INFORMATION = 'MISSING_CREDITOR_INFORMATION',
  BANK_INFO_VALIDATED = 'BANK_INFO_VALIDATED',
  MERCHANT_PAYOUT_DATA_UPDATED = 'MERCHANT_PAYOUT_DATA_UPDATED',
  CALCULATIONS_REQUESTED = 'CALCULATIONS_REQUESTED',
  CALCULATIONS_COMPLETED = 'CALCULATIONS_COMPLETED',
  CALCULATIONS_FAILED = 'CALCULATIONS_FAILED',
  CALCULATIONS_RETRIEVAL_FAILED = 'CALCULATIONS_RETRIEVAL_FAILED',
  COMPLETED = 'COMPLETED',
  INVOICES_RENDERED = 'INVOICES_RENDERED',
  INVOICES_REQUESTED = 'INVOICES_REQUESTED',
  REPORTS_REQUESTED = 'REPORTS_REQUESTED',
  DOCUMENTS_RENDERED = 'DOCUMENTS_RENDERED',
  MISSING_EXTERNAL_ID = 'MISSING_EXTERNAL_ID',
  EMAIL_SENT_TO_MERCHANT = 'EMAIL_SENT_TO_MERCHANT',
  RELEASED_TRANSFER = 'RELEASED_TRANSFER',
  READY_FOR_WLS_TRANSFER = 'READY_FOR_WLS_TRANSFER',
  READY_FOR_WE_TRANSFER = 'READY_FOR_WE_TRANSFER',
}

export enum PayoutIntervalType {
  HEXA_MONTHLY = 'HEXA_MONTHLY',
  SEMI_MONTHLY = 'SEMI_MONTHLY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  CUSTOM = 'CUSTOM',
}

export enum PayoutLevel {
  MERCHANT = 'MERCHANT',
  VENUE = 'VENUE',
}

export type PayoutInterval = {
  type: PayoutIntervalType;
  number: number;
  year: number;
  startDate: string;
  endDate: string;
};

export type MerchantPayout = {
  id: string;
  merchantId: string;
  country: Country;
  venueIds: string[];
  venuePayoutIds: string[];
  status: MerchantPayoutStatus;
  interval: PayoutInterval;
  successfulVenuePayoutIds: string[];
  failedVenuePayoutIds: string[];
  payoutAmount: number;
  archived: boolean;
  payoutLevel: PayoutLevel;
  dossier: MpsDocumentsDossier | null;
};

export type AllMerchantPayouts = {
  isOptedInMerchantLevelArchiving: boolean;
  merchantBankAccount: string;
  currency: Currency;
  payouts: MerchantPayout[];
};

export type BrandPayout = {
  id: string;
  brandId: string;
  venueIds: string[];
  interval: PayoutInterval;
  payoutAmount: number;
  archived: boolean;
};

export type AllBrandPayouts = {
  currency: Currency;
  payouts: BrandPayout[];
};
